import React from "react";

const IntelligentEngineeringSection = ({
  leftImage,
  rightImage,
}) => {
  return (
    <section className="py-10 md:py-14 lg:py-18">
      <div className="container mx-auto px-8 md:px-16 lg:px-24 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-bold mb-4 md:mb-6">
            <span className="">Innovating at the Core of{" "}</span>
            <span className="secondary-text">Intelligent Engineering</span>
          </h2>
          <p className="    max-w-5xl mx-auto">
            Reimagining businesses through intelligent digital innovation
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3">
          <img
            src={leftImage}
            alt="Intelligent Left"
            className="w-full h-full md:h-[330px] lg:h-[250px] object-cover rounded-tr-md rounded-br-md"
          />
        </div>

        <div className="col-span-12 md:col-span-6 primary-bg p-4 rounded-md flex items-center justify-center">
          <p className="text-white p-3 text-center">
            Digital Transformation is the strategic adoption of digital
            technologies to enhance business processes, organizational culture,
            and customer experiences. At Avexa Systems, we leverage advanced
            technologies, data intelligence, and AI-driven solutions to build
            scalable, secure, and future-ready digital ecosystems that enable
            organizations to adapt, innovate, and grow.
          </p>
        </div>

        <div className="col-span-12 md:col-span-3">
          <img
            src={rightImage}
            alt="Intelligent Right"
            className="w-full h-full md:h-[330px] lg:h-[250px] object-cover rounded-tl-md rounded-bl-md"
          />
        </div>
      </div>
    </section>
  );
};

export default IntelligentEngineeringSection;
